<template>
  <el-tag
    :size="size?size: 'small'"
    v-bind:style="
      !selected
        ? { 'border-radius': '4px', border: '1px solid', color: item.color, 'background-color': this.setTransparencyHex(item.color, 0.15), 'border-color': item.color, margin: '1px 4px 3px 1px' }
        : {
            color: item.color,
            'background-color': isButton ? item.color : setTransparencyHex(item.color, 1),
            'border-color': isButton ? item.color : setTransparencyHex(item.color, 1),
            margin: '1px 4px 3px 1px',
            'border-radius': '4px',
            color: '#fff'
          }
    "
    effect="dark"
    class="pointer"
  >
    <div v-if="isButton && selected" class="font-size-11 fw-semibold text-center text-white" style="border-radius: 2px">
      {{ item.name }}
    </div>
    <div v-else class="font-size-11 fw-semibold text-center" style="border-radius: 2px">{{ item.name }}</div>
  </el-tag>
</template>

<script>
export default {
  name: "TagCustom",
  props: ["item", "selected", "isButton", "size"],
  methods: {

  }
};
</script>

<style scoped></style>
